import { createRoutine } from 'redux-saga-routines';

export const editPortfolio = createRoutine('@EDIT_PORTFOLIO/EDITING');
export const showEditPortfolioModal = createRoutine('@EDIT_PORTFOLIO/SHOW');
export const hideEditPortfolioModal = createRoutine('@EDIT_PORTFOLIO/HIDE');
